export const Types = {
    GET_EXTERNAL_SYSTEM_DATAS_REQUEST: "GET_EXTERNAL_SYSTEM_DATAS_REQUEST",
    GET_EXTERNAL_SYSTEM_DATAS_RESPONSE: "GET_EXTERNAL_SYSTEM_DATAS_RESPONSE",
    SET_EXTERNAL_SYSTEM_REQUEST_STATUS: "SET_EXTERNAL_SYSTEM_REQUEST_STATUS",
    SET_EXTERNAL_SYSTEM_REQUEST_FILTER: "SET_EXTERNAL_SYSTEM_REQUEST_FILTER"
}

export const getExternalSystemDatasRequest = (
    StartDate,
    EndDate,
    ChannelId,
    IssueType,
    StatusId
) => ({
    type: Types.GET_EXTERNAL_SYSTEM_DATAS_REQUEST,
    StartDate,
    EndDate,
    ChannelId,
    IssueType,
    StatusId
    
});

export const getExternalSystemDatasRequestSuccess = response => {
    return {
        type: Types.GET_EXTERNAL_SYSTEM_DATAS_RESPONSE,
        payload: response
    }
}

export const getExternalSystemDatasRequestStatus = statu => {
    return {
        type: Types.SET_EXTERNAL_SYSTEM_REQUEST_STATUS,
        payload: statu
    }
}

export const setExternalSystemFilterModel = model => {
    return {
        type: Types.SET_EXTERNAL_SYSTEM_REQUEST_FILTER,
        payload: model
    }
}
